import { DialogContent, DialogHeader, DialogRoot, DialogTitle, ScrollArea } from '@ibsys/kit';
import type { FC } from 'react';
import { cn, DIALOG_CONTENT_SCREEN_BOUNDED, SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';

/** Изображение, открытое увеличенным */
export type LightboxImage = {
  /** Адрес изображения */
  src: string;
  /** Имя изображения — заголовок окна и подпись картинки */
  name: string;
};

type Props = {
  /** Открытое изображение; нет — окно закрыто */
  image: LightboxImage | null;
  onClose: () => void;
};

/**
 * Изображение переписки, увеличенное поверх страницы: в своём размере, но не шире экрана;
 * не поместившееся по высоте прокручивается. Закрывается крестиком или нажатием на фон.
 */
export const AttachmentLightbox: FC<Props> = ({ image, onClose }) => (
  <DialogRoot open={!!image} onOpenChange={(open: boolean) => !open && onClose()}>
    <DialogContent className={cn(DIALOG_CONTENT_SCREEN_BOUNDED, 'w-fit sm:max-w-full')}>
      <DialogHeader>
        <DialogTitle className="truncate pr-6">{image?.name}</DialogTitle>
      </DialogHeader>
      <ScrollArea orientation="vertical" className={SCROLL_AREA_VIEWPORT_BLOCK}>
        {image && <img src={image.src} alt={image.name} className="mx-auto block h-auto max-w-full" />}
      </ScrollArea>
    </DialogContent>
  </DialogRoot>
);
